import React from 'react';
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  actionsContainer: {
    display: 'flex',
    justifyContent: 'space-around'
  }
}))

export default ({children}) => {
  const classes = useStyles();
  return <div className={classes.actionsContainer}>{children}</div>
}